import crc32 from './crc/crc32.js';

/**
 * @memberof ux-tread-crc-code
 * getErrorCode
 * @description Returns a unique string based on domain/resource/version/errorCode
 * @param {string} apiPath - a service api path with both pre and trailing slashes
 * @param {string} errorCode - a service error code, message or status, preferred in that order
 * @returns {string} a unique error code string used for translations or telemetry
 */
export default function getErrorCode(apiPath, errorCode) {
  /*
  Currently the codes are set up as an 8digit code, there may be a time where we need to add a space
  using the next line at the end of line 9 will add a space after the 4th character
  .replace(/([A-z0-9]{4})/, '$1 ')
  */

  // Any 0's would be trimmed off the front of this code, if it's less than 8 characters
  // we need to pad with 0's
  return String("00000000".concat(crc32("".concat(apiPath).concat(errorCode)).toString(16).toUpperCase())).slice(-8);
}